import styled, { Palette, PaletteVariants, Sizes } from 'styled-components';

export type ColorShade = {
  color?: Palette;
  shade?: PaletteVariants;
};

export type CircleProps = {
  size?: Sizes;
} & ColorShade;

export const Circle = styled.div<CircleProps>((props) => {
  const { theme, color, size, shade } = props;
  let resultColor = theme.palette.greyBlack.main;

  if (color) {
    const shadedColor = shade && theme.palette[color][shade];

    resultColor = shadedColor || theme.palette[color].main;
  }

  const resultSize = size ? theme.sizes[size] : theme.sizes.large;

  return `
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    height: ${resultSize};
    width: ${resultSize};
    background-color: ${resultColor};
    border-radius: 50%;
  `;
});
